import defaultTemplateData from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/defaultTemplateData";
import { TemplateDataSchemaType } from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/templateDataSchema";
import { ProgrammeFormData } from "@/lib/api";
import {

createContext,
useCallback,
useContext,
useMemo,
useState,
type PropsWithChildren,
} from "react";



interface MicroSiteContextValue {
templatePayload: TemplateDataSchemaType;
updateTemplatePayload: (patch: Partial<TemplateDataSchemaType>) => void;
updateProgrammePayload: (patch: Partial<ProgrammeFormData>) => void;
resetTemplatePayload: () => void;
programmePayload?: ProgrammeFormData;
}

const MicroSiteContext = createContext<MicroSiteContextValue | undefined>(
undefined,
);

export const MicroSiteProvider = ({ children }: PropsWithChildren) => {
const [templatePayload, setTemplatePayload] = useState<TemplateDataSchemaType>(defaultTemplateData);
const [programmePayload, setProgrammePayload] = useState<ProgrammeFormData | undefined>(undefined);

const updateTemplatePayload = useCallback(
  (patch: Partial<TemplateDataSchemaType>) => {
    setTemplatePayload((prev) => ({ ...prev, ...patch }));
  },
  [],
);

const updateProgrammePayload = useCallback(
  (patch: Partial<ProgrammeFormData>) => {
    setProgrammePayload((prev) => ({ ...(prev ?? {}), ...patch } as ProgrammeFormData));
  },
  [],
);

const resetTemplatePayload = useCallback(() => {
  setTemplatePayload(defaultTemplateData);

  // also reset programme payload
  setProgrammePayload(undefined);
}, []);

const value = useMemo(
  () => ({
    templatePayload,
    programmePayload,
    updateTemplatePayload,
    updateProgrammePayload,
    resetTemplatePayload,
  }),
  [templatePayload, programmePayload, updateTemplatePayload, updateProgrammePayload, resetTemplatePayload],
);

return (
  <MicroSiteContext.Provider value={value}>
    {children}
  </MicroSiteContext.Provider>
);
};

export const useMicroSiteContext = () => {
const context = useContext(MicroSiteContext);
if (!context) {
  throw new Error("useMicroSiteContext must be used within MicroSiteProvider");
}
return context;
};